/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as getBreakdownAction from 'app/library/store/actions/get-breakdown-queue.action';
import { BreakdownService } from 'app/shared/services/';
import { Constants } from '@shared/models/constants.model';
@Injectable()
export class GetBreakdownQueueEffects {
  getGames$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getBreakdownAction.GET_BREAKDOWN_QUEUE),
      switchMap((action: getBreakdownAction.GetBreakdownQueue) => {
        const breakdownPurchases = this.getBreakdownPurchases(action.payload.userProducts);
        if (breakdownPurchases.size) {
          return this.breakdownService.getBreakdownQueueByPurchases([...breakdownPurchases.values()]).pipe(
            map((breakdowns) => {
              return new getBreakdownAction.GetBreakdownQueueSuccess(breakdowns);
            }),
            catchError((error) => of(new getBreakdownAction.GetBreakdownQueueFail(error.message)))
          );
        } else {
          return of(new getBreakdownAction.GetBreakdownQueueSuccess([]));
        }
      })
    )
  );

  constructor(private actions$: Actions, private breakdownService: BreakdownService) {}

  private getBreakdownPurchases(products): Set<number> {
    return products.reduce((acc, product) => {
      if (
        (product.type === Constants.PURCHASE_TYPE.BREAKDOWN ||
          product.type === Constants.PURCHASE_TYPE.BREAKDOWN_ONE_GAME ||
          product.type === Constants.PURCHASE_TYPE.BREAKDOWN_ONE_GAME_TP) &&
        !acc.has(product.id)
      ) {
        acc.add(product.id);
      }
      if (product.addons?.length) {
        product.addons.forEach((addon) => {
          if (
            (addon.type === Constants.PURCHASE_TYPE.BREAKDOWN ||
              addon.type === Constants.PURCHASE_TYPE.BREAKDOWN_ONE_GAME ||
              addon.type === Constants.PURCHASE_TYPE.BREAKDOWN_ONE_GAME_TP) &&
            !acc.has(addon.id)
          ) {
            acc.add(addon.id);
          }
        });
      }
      return acc;
    }, new Set());
  }
}
